var map = {
	"./": [
		"1e4b",
		"chunk-c6161c32"
	],
	"./about": [
		"754b",
		"chunk-db027f86"
	],
	"./about.vue": [
		"754b",
		"chunk-db027f86"
	],
	"./businessIntroduction": [
		"e656",
		"chunk-164f0ab8"
	],
	"./businessIntroduction.vue": [
		"e656",
		"chunk-164f0ab8"
	],
	"./bxcApp": [
		"6b39",
		"chunk-4151a0e2"
	],
	"./bxcApp.vue": [
		"6b39",
		"chunk-4151a0e2"
	],
	"./contactUs": [
		"44b5",
		"chunk-0e0de6fb"
	],
	"./contactUs.vue": [
		"44b5",
		"chunk-0e0de6fb"
	],
	"./corporateNews": [
		"f27c",
		"chunk-82b5fd14"
	],
	"./corporateNews.vue": [
		"f27c",
		"chunk-82b5fd14"
	],
	"./goods": [
		"e524",
		"chunk-64f15c7e"
	],
	"./goods.vue": [
		"e524",
		"chunk-64f15c7e"
	],
	"./index": [
		"1e4b",
		"chunk-c6161c32"
	],
	"./index.vue": [
		"1e4b",
		"chunk-c6161c32"
	],
	"./kcyyApp": [
		"a4c6",
		"chunk-6393d1bb"
	],
	"./kcyyApp.vue": [
		"a4c6",
		"chunk-6393d1bb"
	],
	"./newsDetails": [
		"7590",
		"chunk-1c2183b4"
	],
	"./newsDetails.vue": [
		"7590",
		"chunk-1c2183b4"
	],
	"./productCenter": [
		"3032",
		"chunk-094df114"
	],
	"./productCenter.vue": [
		"3032",
		"chunk-094df114"
	],
	"./strategicJoin": [
		"7d25",
		"chunk-51c25667"
	],
	"./strategicJoin.vue": [
		"7d25",
		"chunk-51c25667"
	],
	"./thothApp": [
		"5a0e",
		"chunk-642d1356"
	],
	"./thothApp.vue": [
		"5a0e",
		"chunk-642d1356"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9dac";
module.exports = webpackAsyncContext;